<template>
  <IQOS :title="$t('subscription.transactions.title')" class="iqos-long iqos-empty" boxClass="container-box p-0">
    <div class="table-container">
      <table class="table iqos-table">
        <thead>
          <th>{{$t('subscription.transactions.number')}}</th>
          <th>{{$t('subscription.transactions.date')}}</th>
          <th>{{$t('subscription.transactions.time')}}</th>
          <th>{{$t('subscription.transactions.system')}}</th>
          <th>{{$t('subscription.transactions.method')}}</th>
          <th>{{$t('subscription.transactions.sum')}}</th>
          <th>{{$t('subscription.transactions.status')}}</th>
        </thead>
        <tbody>
          <tr v-for="(item,index) in transactions" :key="index">
            <td>{{ item.banking_id }}</td>
            <td>{{ item.created_at | formatDate }}</td>
            <td>{{ item.created_at | formatTime }}</td>
            <td>
              <img :src="`/icons/mode-${item.mode == 'inside_lite' ? 'inside-lite' : item.mode}.svg`" alt />
            </td>
            <td>{{ item.card_type.toUpperCase()}} {{ item.card_mask }}</td>
            <td>{{ item.amount }} {{ item.currency }}</td>
            <td>
              <span class="c-green" v-if="item.status == 'success'">{{$t('subscription.transactions.success')}}</span>
              <span class="c-red" v-else>{{$t('subscription.transactions.error')}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import SubscriptionAPI from '@/api/subscription'

import ModeIcon from "@/components/ModeIcon.vue"

export default {
  data() {
    return {
      transactions: []
    };
  },

  components: {
    IQOS
  },
  mounted() {
      SubscriptionAPI.getTransactions(this.$store.state.cafe._id).then(data => {
          this.transactions = data.transactions;
      }).catch(error => {
          this.$store.dispatch('showError', 'subscription_error');
      });
  }
};
</script>

<style scoped>
.table-container {
  width: 122vh;
}

.bills-container {
  width: 100%;
  padding-right: 5.5vh;
}
</style>